"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = void 0;
const ContextTagKeys = require("../shared/util/contextTagKeys");
class Context {
    constructor(packageJsonPath) {
        this.keys = new ContextTagKeys();
        this.tags = {};
    }
}
exports.Context = Context;
Context.DefaultRoleName = "Web";
Context.appVersion = {};
Context.sdkVersion = null;
//# sourceMappingURL=context.js.map